/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import _ from "underscore";
import util from "util/util.js";

var selectFileOptions = {
	accept: '.zip,.shp,.shx,.dbf,.prj,.shp.xml',
	multiple: true
};

function checkFiles(importType, files) {
	var issues = [];

	if(files.length == 1 && files[0].name.match(/.zip$/)) {
		issues.push({
			message: "Zip file detected - OK",
			type: "Info"
		});
	} else if(files.length > 0) {
		var ok = true;
		var basenames = [];
		var extensions = [];
		var requiredExtensions = ["shp", "dbf", "prj"];

		_.each(files, function(file) {
			console.log(file);
			var match = file.name.match(/^(.+)\.(shp|shx|prj|dbf|shp.xml)$/);
			if(match) {
				basenames.push(match[1]);
				extensions.push(match[2]);
			} else {
				issues.push({
					message: "Unsupported file type: " + file.name + " (supported files .shp, .shx, .prj, .dbf, .shp.xml OR a single .zip file containing such files)",
					type: "Error"
				});
				ok = false;
			}
		});

		if(ok) {
			if(util.uniq(basenames).length > 1) {
				issues.push({
					message: "All files must start with the same name (e.g. Example.shp, Example.shx, Example.prj ..)",
					type: "Error"
				});
				ok = false;
			}
		}

		if(ok) {
			_.each(_.difference(requiredExtensions, extensions), function(ext) {
				issues.push({
					message: "Missing required file: " + basenames[0] + "." + ext,
					type: "Error"
				});
				ok = false;
			});
		}

		if(ok) {
			issues.push({
				message: "Detected shapefile: " + basenames[0] + " - OK",
				type: "Info"
			});
		}
	}

	return Promise.resolve(issues);
}

export default {
	selectFileOptions,
	checkFiles
};
